import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { AppShell } from '@/components/layout/AppShell';

/**
 * Guard that wraps every authenticated route. When no access token is
 * available we redirect to `/auth/login`, preserving the original URL so the
 * login form can return the user there afterwards. Once authenticated, the
 * route renders inside the shared `<AppShell />` (sidebar + topbar + content).
 */
export default function PrivateRoute() {
  const accessToken = useAuthStore((s) => s.accessToken);
  const location = useLocation();

  if (!accessToken) {
    return (
      <Navigate
        to="/auth/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <AppShell />;
}
